import type { IconSvgObject } from './types';

const Presentation02Icon: IconSvgObject = [
  ["path", { d: "M3 17H21V8C21 5.17157 21 3.75736 20.1213 2.87868C19.2426 2 17.8284 2 15 2H9C6.17157 2 4.75736 2 3.87868 2.87868C3 3.75736 3 5.17157 3 8V17Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 17H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7 22L12.0001 19L17 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 17.1973V22", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }]
];

export default Presentation02Icon;
